import { createContext } from 'react'

export const HsmReportsContext = createContext()
